import dynamic from "next/dynamic";
import type { GetServerSidePropsContext } from "next/types";
import { SWRConfig } from "swr";

import Bugsnag from "@bugsnag/js";

import { faCompass } from "@fortawesome/free-regular-svg-icons/faCompass";

import FontAwesomeIcon from "components/FontAwesomeIcon";
import ToolPageLayout from "components/ToolPageLayout";
import type { NextPageWithLayout } from "pages/_app";
import Error from "pages/_error";
import {
  authenticatedAccountUrl,
  sessionFromContextCookie,
} from "hooks/useAuthentication";
import { baseFetcher } from "utils/baseFetcher";

const Page = dynamic(() => import("components/ToolDiscoveryPage"), {
  ssr: false,
});

const ToolDiscoveryPage: NextPageWithLayout = () => {
  return <Page />;
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  try {
    const session = sessionFromContextCookie(context);
    const accountId = session?.authenticated?.account_id;
    const accountUrl = authenticatedAccountUrl(accountId);
    const account = await baseFetcher(accountUrl, context);

    try {
      await baseFetcher(`/api/v2/tools/discovery`, context);
    } catch {}

    return {
      props: {
        fallback: {
          [accountUrl]: account,
        },
      },
    };
  } catch (error: any) {
    console.error(
      "[slug].tsx ~ getServerSideProps Tool Discovery Page ~ error",
      error
    );
    Bugsnag.notify(error);
    return {
      props: {
        fallback: {},
      },
    };
  }
}

ToolDiscoveryPage.getLayout = (page, { pageProps }) => {
  const { fallback, errorCode } = pageProps;

  if (errorCode) return <Error statusCode={errorCode} />;

  return (
    <SWRConfig value={{ fallback }}>
      <ToolPageLayout
        title="Discovery"
        breadcrumb={[
          {
            icon: <FontAwesomeIcon icon={faCompass} />,
            title: "Discovery",
            href: `/tools/discovery`,
          },
        ]}
      >
        {page}
      </ToolPageLayout>
    </SWRConfig>
  );
};

export default ToolDiscoveryPage;
